export default {
  Pending: 0,
  Loading: 1,
  LastError: 2
};
